// import { generator, notFoundRouter } from '@/utils/permissions';
import { config } from '@/api/config';
import { resolveSiteLogoURL, setSiteFavicon } from '@/utils/site-logo';
const configs = {
  namespaced: true,
  state: {
    config: {},
    configindex:1
  },
  mutations: {
    SET_LOGO: (state,config) => {
      state.config = config;
    },
    
  },
  getters: {
    getconfig(state) {
      return state.config.www_title;
    },
  },
  actions: {
    async setLogo({ commit }){
      try {
        let data = await config(1);
        commit('SET_LOGO', data);
        setSiteFavicon(resolveSiteLogoURL(data.logo_src, data.public_file_base_url));
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    
    },
  },
};

export default configs;
